import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        navigate("/admin", { state: { user: res.data.user }, replace: true });
      } catch (e) {
        const d = e.response?.data?.detail;
        navigate("/admin", { state: { authError: typeof d === "string" ? d : "Google sign-in failed. Please try again." }, replace: true });
      }
    })();
  }, [location, navigate]);

  return null;
}
